import { render, staticRenderFns } from "./registerOrderTak.vue?vue&type=template&id=7a08a439&scoped=true&"
import script from "./registerOrderTak.vue?vue&type=script&lang=js&"
export * from "./registerOrderTak.vue?vue&type=script&lang=js&"
import style0 from "./registerOrderTak.vue?vue&type=style&index=0&id=7a08a439&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a08a439",
  null
  
)

export default component.exports